module.exports = __webpack_public_path__ + "img/制御工学7_8.6bfa11be.png";